<form [formGroup]="dateFormGroup" class="date-picker-form">
  <div class="picker-containers">
    <mat-form-field
      appearance="fill"
      class="date-picker"
      data-cy="filter-start-date"
    >
      <mat-label>From</mat-label>
      <input
        matInput
        [matDatepicker]="startPicker"
        formControlName="startDate"
        [min]="minDate"
        [max]="maxDate"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="startPicker"
        data-cy="datepicker-toggle"
      ></mat-datepicker-toggle>
      <mat-datepicker #startPicker startView="month"></mat-datepicker>
      @if (dateFormGroup.controls.startDate.hasError('matDatepickerMin')) {
      <mat-error
        >From date must be after {{ minDate.toDateString() }}</mat-error
      >
      } @if (dateFormGroup.controls.startDate.hasError('matDatepickerMax')) {
      <mat-error
        >From date must be before {{ maxDate.toDateString() }}</mat-error
      >
      }
    </mat-form-field>

    <mat-form-field
      appearance="fill"
      class="date-picker"
      data-cy="filter-end-date"
    >
      <mat-label>To</mat-label>
      <input
        matInput
        [matDatepicker]="endPicker"
        formControlName="endDate"
        [min]="minDate"
        [max]="maxDate"
        [errorStateMatcher]="matcher"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="endPicker"
        data-cy="datepicker-toggle"
      ></mat-datepicker-toggle>
      <mat-datepicker #endPicker startView="month"></mat-datepicker>
      @if (dateFormGroup.controls.endDate.hasError('matDatepickerMin')) {
      <mat-error>To date must be after {{ minDate.toDateString() }}</mat-error>
      } @if (dateFormGroup.controls.endDate.hasError('matDatepickerMax')) {
      <mat-error>To date must be before {{ maxDate.toDateString() }}</mat-error>
      } @if (dateFormGroup.hasError('startGreaterThanEnd') &&
      !dateFormGroup.controls.endDate.hasError('matDatepickerMin') &&
      !dateFormGroup.controls.endDate.hasError('matDatepickerMax')) {
      <mat-error> To date must be after From date </mat-error>
      }
    </mat-form-field>
  </div>
</form>
